
  export default {
    name: 'SectionHeadlineWithText',
    props: {
      section: {
        type: Object,
        required: false,
        default: () => {},
      },
      loggedIn: {
        type: Boolean,
        required: false,
        default: false,
      },
    },
    serverCacheKey: function (props) {
      return 'section-headline-with-text-' + props.section.id;
    },
  };
